module.exports = __webpack_public_path__ + "img/inzerce.52d4b0e6.svg";